<template>
    <section class="mt-4 mb-4">
        <div class="container">
            <h1 class="text-center mb-4">Search Products</h1>
            <div class="row">
                <div class="col-md-12">
                    <b-input-group class="mt-3">
                        <b-form-select v-model="selectedBrand" 
                            :options="brandOptions"
                            @change="searchProducts"
                            v-if="brandOptions.length > 0"></b-form-select>
                        <b-form-select v-model="selectedCategory" 
                            :options="categoryOptions"
                            @change="searchProducts"
                            v-if="categoryOptions.length > 0"></b-form-select>
                        <b-form-input type="search"
                            v-model="keyword" 
                            @input="searchProducts"
                            placeholder="Enter keyword"></b-form-input>
                        <b-input-group-append>
                            <b-input-group-text>
                                <i class="fa fa-search"></i>
                            </b-input-group-text>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="search-results"
                        v-if="results.length > 0">
                        <div class="row g-1">
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-3" v-for="product in results">
                                <div class="card">
                                    <a :href="appUrl+'/products/'+product.id">
                                        <div class="text-center"
                                            v-if="product.images[0]"> 
                                            <img :src="appUrl+'/'+product.images[0].image_path" 
                                                :alt="product.title" 
                                                class="img-fluid"
                                                width="100%"> 
                                        </div>
                                        <div class="text-center"
                                            v-else> 
                                            <img :src="appUrl+'/images/default-image.jpg'" 
                                                :alt="product.title" 
                                                class="img-fluid"
                                                width="100%"> 
                                        </div>
                                    </a>
                                    <div class="product-details m-3 text-center">
                                        <a :href="appUrl+'/products/'+product.id">
                                            <span class="products-name d-block">{{ product.title }}</span>
                                        </a>
                                        <span class="products-price strike"
                                            v-if="product.offer_price">
                                            <i class="fa fa-rupee-sign"></i> 
                                            {{ product.mrp }}
                                        </span>
                                        <span class="products-price"
                                            v-else>
                                            <i class="fa fa-rupee-sign"></i> 
                                            {{ product.mrp }}
                                        </span>
                                        <span class="products-price"
                                            v-if="product.offer_price">
                                            <i class="fa fa-rupee-sign"></i> 
                                            {{ product.offer_price }}
                                        </span>
                                        <div class="my-2 text-center">
                                            <dl class="param param-inline">
                                                <dd>
                                                    <b-form-spinbutton id="product-quantity"
                                                        class="text-center"
                                                        size="lg" 
                                                        v-model="product.cart_quantity"
                                                        min="0"
                                                        :max="product.min_quantity * 10"
                                                        :step="product.min_quantity"
                                                        @change="addToCart(product.id, $event)"
                                                        inline></b-form-spinbutton>
                                                </dd>
                                            </dl>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        data() {
            return {
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
                keyword: '',
                results: [],
                categoryOptions: [],
                brandOptions: [],
                selectedCategory: null,
                selectedBrand: null,
            };
        },
        mounted() {
            this.getSearchOptions();
        },
        methods: {
            searchProducts() {
                var that = this;
                if (that.keyword.trim() != '' || that.selectedCategory != null || that.selectedBrand != null) {
                    axios.post('api/search-products', {
                        keyword: that.keyword,
                        category: that.selectedCategory,
                        brand: that.selectedBrand,
                    })
                    .then(function(response) {
                        that.results = response.data.results;
                    })
                    .catch(function (response) {
                        console.log(response);
                        alert('Something went wrong, please try again.');
                    });
                } else {
                    that.results = [];
                }
            },
            addToCart(id, quantity) {
                var that = this;
                axios.post('api/add-to-cart', {
                    id: id,
                    quantity: quantity,
                })
                .then(function(response) {
                    if (response.data.success) {
                        that.$notify({
                            group: 'cart',
                            title: 'Success',
                            type: 'success',
                            text: response.data.message
                        });
                    } else {
                        that.$notify({
                            group: 'cart',
                            title: 'Error',
                            type: 'error',
                            text: response.data.message
                        });
                    }
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            getSearchOptions() {
                var that = this;
                axios.get('api/get-search-options')
                .then(function(response) {
                    that.categoryOptions = response.data.categories;
                    that.brandOptions = response.data.brands;
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            }
        }
    };
</script>
